import { instance, instanceWithAuth, instanceWithReauth } from "@/api/index";

function checkId(param) {
    return instance.get("/user/check-id", { params: param });
}
function findId(param) {
    return instance.get("/user/find-id", { params: param });
}
function initPw(param) {
    return instanceWithAuth.post("/user/init-pw", param);
}
function checkPw(param) {
    return instanceWithAuth.post("/user/check-pw", param);
}
function refreshUser(param) {
    return instance.get("/auth/refresh", { params: param });
}
function join(param) {
    return instance.post("/user/join", param);
}
function getUserInfo() {
    return instanceWithAuth.get("/user/user-info");
}
function getMyInfo() {
    return instanceWithReauth.get("/user/my-info");
}
function modifyUser(param) {
    return instanceWithReauth.post("/user/modify", param)
}
function changePw(param) {
    return instanceWithReauth.post("/user/change-pw", param)
}
function cancelMember() {
    return instanceWithAuth.post("/user/cancel-member");
}
function getDuns3YearList(param) {
    return instanceWithAuth.get("/user/duns-3y-list", { params: param })
}
function sendDunsMail(param) {
    return instanceWithAuth.get("/user/send-duns-mail", { params: param });
}
function getActiveDunsList() {
    return instanceWithAuth.get("/user/duns-active-list");
}
function getBir3YearList(param) {
    return instanceWithAuth.get("/user/bir-3y-list", { params: param })
}
function getActiveBirList() {
    return instanceWithAuth.get("/user/bir-active-list");
}



export {
    checkId, findId, initPw, checkPw, refreshUser, join,
    getUserInfo, modifyUser, changePw, cancelMember,
    getDuns3YearList, sendDunsMail, getActiveDunsList,
    getBir3YearList, getActiveBirList, getMyInfo
};